import { markRaw } from 'vue'
import { toast } from 'vue-sonner'
import AppToast from '@/components/app/AppToast.vue'
import { apiErrorMessage } from '@/lib/errors'

/**
 * Retours d'action (SP-37) : un toast à la marque pour chaque enregistrement réussi ou
 * échoué. Messages courts (règle MOA du 22 octobre 2026) : « Enregistré », « Erreur,
 * réessayez », et le message de l'API quand il dit quelque chose de plus.
 */
const component = markRaw(AppToast)

const GENERIC_ERROR = 'Une erreur est survenue.'

export function notifySuccess(title = 'Enregistré'): void {
  toast.custom(component, {
    componentProps: { variant: 'success', title: title.replace(/\.$/, '') },
    duration: 4000,
  })
}

/** `detail` : le message à montrer sous le titre, ou une erreur dont on tire celui de l'API. */
export function notifyError(detail?: unknown): void {
  const message = typeof detail === 'string' ? detail : detail ? apiErrorMessage(detail) : ''
  toast.custom(component, {
    componentProps: {
      variant: 'error',
      title: 'Erreur, réessayez',
      detail: message && message !== GENERIC_ERROR ? message : undefined,
    },
    duration: 6000,
  })
}
